import React, { Component } from 'react'
import './sellingCallout.css'
import NumberFormat from 'react-number-format'
import { convertCents } from '../../utils'
import cloudinary from 'cloudinary-core'
import { CLOUDINARY_NAME } from '../../../constants/images/cloudinary'
import { Link } from 'react-router-dom'
import getSymbolFromCurrency from 'currency-symbol-map'
import { Image } from '../../elements/index'
const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
})

class SellingCallOut extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const {
      ownerLink,
      className,
      isPartner,
      sellerAvatarCloudinaryID,
      sellerName,
      sellPriceCents,
      sellPriceCurrency,
    } = this.props

    return (
      <div className={'selling-callout-wrap has-text-centered ' + className}>
        {/* <div className="selling-callout-header">Own It</div> */}
        <div className="selling-callout">
          <Link to={ownerLink}>
            <Image
              className="is-inline-block mb-2"
              src={cl.url(sellerAvatarCloudinaryID, {
                gravity: 'center',
                height: 100,
                width: 100,
                crop: 'fill',
                format: 'jpg',
                quality: 80,
              })}
              rounded
              size={96}
              alt={sellerName + "'s Profile"}
            />
          </Link>
          {isPartner && (
            <p>
              {/* This motorcycle can currently be purchased through{' '} */}
              <strong>{sellerName}. is selling this bike for</strong>
            </p>
          )}
          {!isPartner && (
            <p className="sell-message">
              {sellerName} is selling this bike for
            </p>
          )}

          {/* {monthlyPriceCents > 0 && ( //this needs to be put in the api later and stuck into the dealer info.
            <p className="mt-3 mb-2 is-size-2 has-text-weight-bold">
              <NumberFormat
                value={convertCents(monthlyPriceCents)}
                displayType={'text'}
                thousandSeparator={true}
                prefix={getSymbolFromCurrency(monthlyPriceCurrency)}
              />
              <span className="is-size-6">/mo *</span>
            </p>
          )} */}

          <p className="price">
            <NumberFormat
              value={convertCents(sellPriceCents)}
              displayType={'text'}
              thousandSeparator={true}
              prefix={getSymbolFromCurrency(sellPriceCurrency)}
            />
            {/* {isPartner && (
              <div className="is-size-7 has-text-grey my-3">
                *plus tax. Estimated monthly payment based on 72 Months
                financing at 9.99% APR with 20% down.
              </div>
            )} */}
          </p>

          <p className="is-paragraph-text mb-3">
            Reach out for inquiries to own this bike!
          </p>
          {/* 
          <PartnerContactForm
            className="is-yellow-btn"
            partnerID={this.props.sellerID}
            motorcycleUUID={motorcycleUUID}
            triggerText={getPartnerButtonText(this.props.partnerType)}
            header={getPartnerContactFormText(this.props.partnerType)}
          /> */}
        </div>
      </div>
    )
  }
}

export default SellingCallOut

SellingCallOut.defaultProps = {
  motorcycleUUID: null,
  userType: 'partner', //partner/user
  sellPriceCents: 0,
  sellPriceCurrency: 'USD',
  sellerAvatarCloudinaryID: null,
  sellerID: null,
  sellerName: 'Name Missing',
  partnerType: null,
  monthlyPriceCents: 100,
  monthlyPriceCurrency: 'USD',
}
